package com.macrofocus.eflux.ui.perspective

import com.macrofocus.eflux.BuildKonfig
import com.macrofocus.eflux.components.EFluxContext
import com.macrofocus.eflux.ui.AnchorItem
import com.macrofocus.eflux.ui.Logo
import com.macrofocus.eflux.ui.styledMacrofocusIcon
import emotion.react.css
import i18next.invoke
import i18next.useTranslation
import js.objects.unsafeJso
import mui.material.PaletteMode
import mui.material.Typography
import mui.material.styles.Palette
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.div
import react.useRequired
import web.cssom.Color
import web.cssom.Overflow
import web.cssom.px
import web.cssom.rem

external interface AboutProps : Props {
    var guide: Boolean?
    var support: Boolean?
}

val About = FC<AboutProps> { props ->
    val context = useRequired(EFluxContext)
    val theme = useTheme<Theme>()
    val (t, _) = useTranslation()

    val (getExpertMode, _) = useProperty(context.dataLoader.exportMode)

//            Subtitle1 {
//                label = t("appMenu.about.label")
//            }

    Logo {
        version = BuildKonfig.efluxVersion
        logo = if (theme.palette.unsafeCast<Palette>().mode == PaletteMode.light) "/sg-eflux-logo.svg" else "/sg-eflux-logo-neg.svg"
//        marginLeft = 4.75.rem
    }

    if(props.guide != false) {
        AnchorItem {
            //            classes,
            id = "dev-guide"
            label = t("appMenu.links.dev-guide")
            href = "/doc/EFlux Developer Guide.pdf"
        }
    }

//        divider {}
//        anchorItem(
//            classes,
//            id = "github", label = t("appMenu.links.github"), href = "https://github.com/macrofocus/eflux"
//        )
    if(props.support != false) {
        AnchorItem {
            //            classes,
            id = "email"
            label = t("appMenu.links.email")
            href = "mailto:support@macrofocus.com"
        }
    }

    if(getExpertMode) {
        AnchorItem {
            id = "console"
            label = t("appMenu.links.console")
            href = "/console/"
        }
    }

    div {
        style = unsafeJso {
            overflowX = Overflow.hidden
        }
        Typography {
//                attrs.classes = classes.developed
            sx {
                fontSize = 0.7.rem
                paddingLeft = 4.5.rem
                color = Color("#808080")
            }

            +"Developed by"
        }

//                link {
//                    href = "https://www.macrofocus.com/"
        styledMacrofocusIcon {
            marginLeft = 3.0.rem
        }
//                }

        ReactHTML.img {
            css {
                height = 34.1665.px
                padding = 4.px
                marginLeft = 4.5.rem
            }

            src = if (theme.palette.unsafeCast<Palette>().mode == PaletteMode.light) "/QuantumLogo_Tag.svg" else "/QuantumLogo_Tag (white text).svg"
        }
    }

//        iconButton {
//            attrs["size"] = "small"
//            attrs["aria-label"] = "Macrofocus"
//            attrs.title = "Macrofocus"
//            attrs.color = ButtonColor.inherit
//            attrs.onClickFunction = { _ -> window.open("https://www.macrofocus.com/")}
//
//            styledMacrofocusIcon {}
//        }
}
